/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySalesforceIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-salesforce" */ './utils').then((m) => m.SalesforceIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/salesforce/icon' },
);

const LazySalesforceSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-salesforce-search-result" */ './utils').then(
			(m) => m.SalesforceSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/salesforce/search-result-icon' },
);

const LazySalesforceIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-salesforce-borderless" */ './utils').then(
			(m) => m.SalesforceIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/salesforce/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const SalesforceIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySalesforceIconComponent />
	</Suspense>
);

export const SalesforceSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySalesforceSearchResultIconComponent />
	</Suspense>
);

export const SalesforceIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySalesforceIconBorderlessComponent />
	</Suspense>
);
